<template>
  <div>
    <div class="overlay" @click="$emit('close')"></div>
    <div class="modal_fixed">
      <div class="popup_box op_down modal_cont" id="">
        <img src="static/images/store/icon-close-back-popup.svg" class="btn_close" @click="$emit('close')">
        <h1>{{ getTranslations.home_modals_confirm_purchase_purchase }}</h1>
        <img src="static/images/popups/prize-spin.svg" class="op_down_img">
        <p>
          <b>
            {{ getBundleData.numberOfCoins ? getBundleData.numberOfCoins + ' ' + getTranslations.home_modals_confirm_purchase_pin_games: '' }}
            {{getBundleData.numberOfCoins && getBundleData.points?getTranslations.home_modals_confirm_purchase_successfull_and :''}}
            {{ getBundleData.points ? getBundleData.points + ' ' + getTranslations.home_store_points : '' }}
            – {{ getBundleData.price }} {{ getBundleData.currencyCode }}
          </b>
        </p>
        <p>{{ getTranslations.home_modals_confirm_purchase_pin_we_have_sent }}</p>
        <form class="edit_prof_input pin">
          <div :class="['form-group', errorMessage ? 'has-warning' : '' ]">
            <input type="text"
                   @keyup="check()"
                   class="form-group__textfield phone_input"
                   v-model="pin"
                   :placeholder="getTranslations.home_modals_confirm_purchase_pin_enter_the_4"/>
            <span v-show="errorMessage"
                  class="form-group__feedback">
                {{ message }}
              </span>
          </div>
        </form>
        <button type="button" @click.prevent="purchaseBundle()">
          {{ getTranslations.home_modals_confirm_purchase_pin_confirm_button }}
        </button>
        <a v-if="integrationCheck()" style="cursor: pointer" @click="$emit('close')" class="exit_link"> {{ getTranslations.project_config_visitor_register_2_exit }} </a>
      </div>
    </div>
  </div>
</template>

<script>
  /* eslint no-console: "off", no-param-reassign: ["error", { "props": false }], no-use-before-define: ["error", { "variables": false }] */
import { mapGetters, mapActions, mapState, mapMutations } from 'vuex';
import modals from '@/common/modals';
import ConfirmPurchaseSuccessful from './ConfirmPurchaseSuccessful';
import ConfirmPurchaseForPinError from './ConfirmPurchaseForPinError';
import FailedPurchase from './FailedPurchase';

export default {
  name: 'confirm-purchase-for-pin',
  data() {
    return {
      errorMessage: false,
      message: '',
      pin: '',
      showedModal: false,
      buttonEnabled: true,
    };
  },
  methods: {
    ...mapMutations('common', [
      'storeModalForStore',
    ]),
    ...mapActions('profile', [
      'getUserLoginDetails',
      'chargePinCall',
    ]),
    check() {
      const validPinRegex = /^[0-9]{0,8}$/;
      const validPin = this.pin.match(validPinRegex);
      if (!validPin) {
        this.message = this.getTranslations.home_modals_confirm_purchase_pin_oops;
        this.errorMessage = true;
      } else {
        this.errorMessage = false;
        this.message = '';
      }
    },
    showModal() {
      modals.showHideModalInStore(this);
    },
    purchaseBundle() {
      if (!this.errorMessage && (this.pin.length >= 4 && this.pin.length <= 8)) {
        this.buttonEnabled = false;
        this.getUserLoginDetails().then(() => {
          const bundleInfo = {
            bundleId: this.bundleId,
            pin: this.pin,
          };
          this.chargePinCall({ value: bundleInfo }).then(() => {
            this.buttonEnabled = true;
            if (this.chargePinResponse === 'OPERATION_SUCCESS') {
              this.storeModalForStore(ConfirmPurchaseSuccessful);
              this.$emit('bundlePurchase');
            } else if (this.chargePinResponse === 'WRONG_PIN') {
              this.errorMessage = true;
              this.message = this.getTranslations.home_modals_confirm_purchase_pin_oops;
            } else if (this.chargePinResponse === 'NO_BALANCE') {
              this.storeModalForStore(FailedPurchase);
            } else {
              this.storeModalForStore(ConfirmPurchaseForPinError);
            }
            this.showModal();
          });
        });
      } else {
        this.message = this.getTranslations.home_modals_confirm_purchase_pin_oops;
        this.errorMessage = true;
      }
    },
    integrationCheck() {
      return this.integrationHeader === this.availableIntegrations.DU_ETISALAT.name;
    },
  },
  computed: {
    ...mapState('profile', [
      'chargePinResponse',
      'bundleId',
    ]),
    ...mapState('common', [
      'integrationHeader',
      'availableIntegrations',
    ]),
    ...mapGetters('profile', [
      'getBundleData',
    ]),
    ...mapGetters('i18n', [
      'getTranslations',
    ]),
  },
};
</script>



// WEBPACK FOOTER //
// src/components/home/modals/store/ConfirmPurchaseForPin.vue